/**
 * @generated SignedSource<<c30c64201d8c447494d4d8cf97eef649>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraSprintState = "ACTIVE" | "CLOSED" | "FUTURE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type GroupHeader$data = {
  readonly fieldType: string | null | undefined;
  readonly fieldValue: {
    readonly __typename: string;
    readonly issueTypes?: ReadonlyArray<{
      readonly hierarchy: {
        readonly level: number | null | undefined;
      } | null | undefined;
      readonly issueTypeId: string | null | undefined;
    }>;
    readonly sprint?: {
      readonly state: JiraSprintState | null | undefined;
    };
    readonly " $fragmentSpreads": FragmentRefs<"AtlasProjectGroupHeader" | "CategoryGroupHeader" | "GoalGroupHeader" | "GroupPickerGroupHeader" | "IssueTypeGroupHeader" | "LabelGroupHeader" | "OptionGroupHeader" | "PriorityGroupHeader" | "ResolutionGroupHeader" | "SprintGroupHeader" | "StatusGroupHeader" | "StoryPointsGroupHeader" | "UserGroupHeader" | "VersionGroupHeader">;
  } | null | undefined;
  readonly id: string;
  readonly issueCount: number | null | undefined;
  readonly " $fragmentType": "GroupHeader";
};
export type GroupHeader$key = {
  readonly " $data"?: GroupHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "GroupHeader",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "fieldType"
    },
    {
      "kind": "ScalarField",
      "name": "issueCount"
    },
    {
      "kind": "LinkedField",
      "name": "fieldValue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "FragmentSpread",
          "name": "PriorityGroupHeader"
        },
        {
          "kind": "FragmentSpread",
          "name": "UserGroupHeader"
        },
        {
          "kind": "FragmentSpread",
          "name": "StatusGroupHeader"
        },
        {
          "kind": "FragmentSpread",
          "name": "CategoryGroupHeader"
        },
        {
          "kind": "FragmentSpread",
          "name": "OptionGroupHeader"
        },
        {
          "kind": "FragmentSpread",
          "name": "VersionGroupHeader"
        },
        {
          "kind": "FragmentSpread",
          "name": "SprintGroupHeader"
        },
        {
          "kind": "FragmentSpread",
          "name": "StoryPointsGroupHeader"
        },
        {
          "kind": "FragmentSpread",
          "name": "GoalGroupHeader"
        },
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "AtlasProjectGroupHeader"
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "LabelGroupHeader"
        },
        {
          "kind": "FragmentSpread",
          "name": "IssueTypeGroupHeader"
        },
        {
          "kind": "FragmentSpread",
          "name": "GroupPickerGroupHeader"
        },
        {
          "kind": "FragmentSpread",
          "name": "ResolutionGroupHeader"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueTypes",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "issueTypeId"
                },
                {
                  "concreteType": "JiraIssueTypeHierarchyLevel",
                  "kind": "LinkedField",
                  "name": "hierarchy",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "level"
                    }
                  ]
                }
              ]
            }
          ],
          "type": "JiraJqlIssueTypeFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "sprint",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "state"
                }
              ]
            }
          ],
          "type": "JiraJqlSprintFieldValue"
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetGroup"
};

(node as any).hash = "41baca64a8150960836113c6c55178c3";

export default node;
